

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { AuthenticatedLayout } from "../../layouts";
import { WireTransferSetup } from "../../components/WireTransferSetup";

export const WireTransferSetupPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Wire Transfer"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "Wire Transfer", navigateTo: "/wire-transfer" }, // change later 
      ]}
      mainContents={<WireTransferSetup />}
    />
  );
};
